import React, { useRef } from "react";
import { ShiftAdjustTimePicker } from "./ShiftAdjustTimePicker";
import { TimeArrow } from "../arrow";
import {
  ShiftAdjustClockSectionContainer,
  ShiftAdjustClockSectionTitle,
  ShiftAdjustClockInputsContainer,
  ShiftAdjustMealBreakActions,
  ShiftAdjustPlaceholder,
} from "./styledComponents";
import { useFocusGroup } from "../../../../../../shared/hooks/useFocusGroup";

export type ShiftAdjustClockSectionProps = {
  clockIn?: Date;
  clockOut?: Date;
  setClockIn: (date: Date) => void;
  setClockOut: (date: Date) => void;
  formattedTimezone?: string;
};

export const ShiftAdjustClockSection = ({
  clockIn,
  clockOut,
  setClockIn,
  setClockOut,
  formattedTimezone,
}: ShiftAdjustClockSectionProps) => {
  const clockInOverlayRef = useRef<HTMLElement|null>(null);
  const clockOutOverlayRef = useRef<HTMLElement|null>(null);

  const {
    hasFocus: showKeyboardInputs,
    containerRef,
    focusProps,
  } = useFocusGroup({
    extraRefs: [clockInOverlayRef, clockOutOverlayRef],
  });

  return (
    <ShiftAdjustClockSectionContainer
      tabIndex={0}
      ref={containerRef as React.RefObject<HTMLDivElement>}
      {...focusProps}
    >
      <ShiftAdjustClockSectionTitle>Clock in and Clock out</ShiftAdjustClockSectionTitle>
      <ShiftAdjustClockInputsContainer>
        <ShiftAdjustTimePicker
          label="Clock in"
          setDate={setClockIn}
          date={clockIn}
          showKeyboardInput={showKeyboardInputs}
          onOverlayShow={(overlay) => {clockInOverlayRef.current = overlay;}}
          onOverlayHide={() => {clockInOverlayRef.current = null;}}
          formattedTimezone={formattedTimezone}
        />
        <TimeArrow />
        <ShiftAdjustTimePicker
          label="Clock out"
          setDate={setClockOut}
          date={clockOut}
          showKeyboardInput={showKeyboardInputs}
          onOverlayShow={(overlay) => {clockOutOverlayRef.current = overlay;}}
          onOverlayHide={() => {clockOutOverlayRef.current = null;}}
          formattedTimezone={formattedTimezone}
        />
        <ShiftAdjustMealBreakActions>
          <ShiftAdjustPlaceholder />
        </ShiftAdjustMealBreakActions>
      </ShiftAdjustClockInputsContainer>
    </ShiftAdjustClockSectionContainer>
  );
};
